export default __webpack_public_path__ + "static/media/burkar.6aff063c.jpeg";